import type { StateCreator } from 'zustand'

import type { WorkspacesDataSlice, WorkspacesStore } from '../types'

const initialState = {
  workspaces: [],
  currentWorkspace: null,
  loading: false,
  error: null,
  createProjectForWorkspaceId: null,
  isCreatingWorkspace: false,
}

export const createWorkspacesDataSlice: StateCreator<
  WorkspacesStore,
  [['zustand/immer', never]],
  [],
  WorkspacesDataSlice
> = () => initialState
